<div class="p-grid" id="mu-auth-register">
  <div class="p-col-12 mu-without-padding">
    <h1 class="mu-layout-auth-title" translate="context.register.title"></h1>
    <h1 class="mu-layout-auth-sub-title" translate="context.register.subTitle"></h1>
  </div>
  <div class="p-col-12 mu-without-padding">
    <app-auth-register-create-form
      [formData]="registerForm"
      [countriesList]="countries"
      [showLoginLoading]="showLoginLoading"
      [actionList]="actionList"
      [sendSmsAction]="actionListEnum.SEND_SMS"
      [changeCountryAction]="actionListEnum.CHANGE_COUNTRY"
    ></app-auth-register-create-form>
  </div>
</div>
